/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// TABS : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	tabs: {
		'& .tabheader': {
			display: 'flex',
			alignItems: 'center',
		},
		'& .tabbody': {
			background: theme.color.light.light.swatch,
			borderRadius: pxToEm(4),
			border: replacePXinStringWithEM(`1px solid #ECF0F7`),
			boxShadow: replacePXinStringWithEM(`0 1px 1px 0 #EDF1FA`),
			width: '100%',
			position: 'relative',
			padding: replacePXinStringWithEM('25px 40px'),
			textAlign: 'left',
			zIndex: '1',
			transition: 'height .3s linear 0s'
		}
	}
});